export default __webpack_public_path__ + "static/AG_logo_wword-2x-c3ba36411448560d8d785a7d473b0fa3.png";